import React from "react";
import { CgClose } from "react-icons/cg";
import { AiOutlineInfoCircle } from "react-icons/ai";

import LineButton from "../../../../components/buttons/LineButton";
import { useSelector } from "react-redux";

const AttachmentInfo = ({ onClose }) => {
    const userType = useSelector((state) => state.auth.user?.user_type)

    return (
        <div id="myModal" className="popup custom-popup-overlay popup-center">
            <div className="modal-dialog modal-appeal-details appeal-reason-popup">
                <div className="modal-content appeal-confirmation-popup" style={{ height: "max-content" }}>
                    <div onClick={onClose} className="d-flex justify-content-end croseicn">
                        <CgClose
                            style={{
                                color: "#D1D5DB",
                                height: "30px",
                                width: "30px",
                            }}
                        />
                    </div>
                    <div className="modal-body popup-content">
                        <div className="mt-4">
                            <h5>Attachment:</h5>
                            <p style={{ width: "100%", textAlign: "left" }}>{`At least ${userType == "3" ? "4" : "2"} files are required.`}</p>
                            <div className="d-flex align-items-center">
                                <AiOutlineInfoCircle
                                    style={{
                                        color: "#6B7280",
                                        height: "20px",
                                        width: "20px",
                                        marginRight: "8px",
                                    }}
                                />
                                <span>Note: Please attach following documents:</span>
                            </div>
                            <ul className="mt-2">
                                {userType == "3" ? (
                                    <>
                                        <li>A copy of the programme kit including detail of programme outline</li>
                                        <li>A sample of poster, brochures, or flyers (promotional purpose).</li>
                                        <li>A sample of certificate (certification after completion of the programme or after the test).</li>
                                        <li>Speaker or trainer profiles for each related course.</li>
                                        <li>Documentary evidence from certification body (for professional certification course only)</li>
                                        <li>Any other relevant documentation deemed supportive of the application.</li>
                                    </>
                                )
                                    : (
                                        <>
                                            <li>Proof of attendance</li>
                                            <li>Program Book / Tentative Program</li>
                                            <li>Course Structure</li>
                                            <li>Documented Evidence</li>
                                            <li>Assessment Schedule/Forms & Accreditation Visit</li>
                                            <li>Certificate/Exam Result/Progress reports verified by supervisors</li>
                                            <li>Letter of Appointment/Appreciation for Activity or other means</li>
                                        </>
                                    )
                                }
                            </ul>
                        </div>
                    </div>
                    <div className="d-flex gap-3 justify-content-end mt-4">
                        <LineButton className="AppealConfirmation-yes-btn" onClick={onClose}>
                            Close
                        </LineButton>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AttachmentInfo;
